import { Link } from 'react-router-dom';

const ValentineZikkiPortfolio = ({ isPreview = false }) => {
  const videos = [
    {
      id: 1,
      title: "",
      embedUrl: "https://www.youtube.com/embed/HexqLdALlQk?si=_xJ4-4xQdhl7XV_y",
      description: "Hybrid theatre performance"
    },
    {
      id: 2,
      title: "",
      embedUrl: "https://www.youtube.com/embed/R0spU-U9dDA?si=W2hPY9nfav_QZ2EZ",
      description: "Professional voiceover work"
    },
    {
      id: 3,
      title: "",
      embedUrl: "https://www.youtube.com/embed/e4nT-P-T_M4?si=UM_b2FIKaS5CQZkH",
      description: "Commercial advertisement"
    },
    {
      id: 4,
      title: "",
      embedUrl: "https://www.youtube.com/embed/nR23iX-JfSc?si=zsdlNIOax7Gw9SmJ",
      description: "Commercial advertisement"
    }
  ];

  if (isPreview) {
    return (
      <section className="portfolio-preview-section">
        <div className="container">
          <h2 className="section-title-centered">Meet the Founder</h2>
          <p className="portfolio-subtitle">
            Learn more about Valentine Zikki's artistic journey, research practice,
            and work across theatre, safeguarding, NeuroArts, and emerging technologies.
          </p>

          <div className="portfolio-preview-content">
              <div className="portfolio-cta">
                <Link to="/valentine-zikki" className="btn">Read Full Biography</Link>
              </div>
          </div>
        </div>
      </section>
    );
  }

  // Full portfolio page
  return (
    <>
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Valentine Zikki</h1>
          <p className="hero-cta">Biography & Artist Statement</p>
        </div>
      </section>

      {/* Artist Statement Section */}
      <section className="portfolio-full-section">
        <div className="container">
          <div className="portfolio-top-row">
            {/* Left Column - Image */}
            <div className="portfolio-image-col">
              <div className="image-frame-large">
                <img
                  src="/images/zikki.jpg"
                  alt="Valentine Zikki"
                  className="portfolio-image-full"
                />
              </div>
            </div>

            {/* Right Column - Artist Statement Intro */}
            <div className="portfolio-statement-col">
              <h2 className="section-title-left">Valentine Zikki</h2>
              <p className="statement-intro">
                Valentine Zikki is a Kenyan writer, producer, actor, creative researcher,
                and cultural strategist whose work sits at the intersection of artistic practice,
                cultural sustainability, safeguarding,
                neuro-inclusive creative systems, and emerging technologies.
              </p>
            </div>
          </div>

          {/* Full Statement Below */}
          <div className="portfolio-full-text">
            <h3 className='section-title-left'>Artist Statement</h3>
            <p>
              With over two decades of experience across theatre, film, music,
              advertising, and creative sector development, her practice bridges
              performance, research, and systems thinking. Her work examines how African
              creative ecosystems can become safer, more inclusive, technologically engaged,
              and capable of preserving artistic knowledge across generations.
            </p>

            <p>
              She is the founder and lead researcher of ZIRAYA Institute, a research,
              artistic, and advocacy hub exploring creative sustainability, institutional
              memory, NeuroArts, safeguarding, and African futures shaped by technology
              and storytelling.
            </p>
            <p>
              Her current research, From Survival to Sustainability:
              Rethinking Artist Livelihoods in Kenya's Independent Theatre Sector,
              investigates career continuity, knowledge transfer, documentation,
              and the systems required to sustain theatre practice in Kenya.
            </p>

            <p>
              As an artist, Zikki created Mpenzi Mashini (Dear Machine),
              a hybrid theatrical work that explores human–AI collaboration,
              gender, intimacy, and African speculative futures. Her broader
              artistic career includes stage performance, music composition for
              film and theatre, voice performance, and creative production.
            </p>
            <p>
              She is the founder of the Safer Workspaces in the Creative Sector
              initiative and creator of Fichua Pazia, Kenya's first safeguarding
              toolkit developed specifically for the creative industries. Through SPCTRM (Spectrum),
              she is also developing NeuroArts initiatives that explore
              neurodivergence, creativity, and inclusive artistic practice.
            </p>
            <p>
              Zikki's work is driven by a central question: <br/>
              How do we build creative ecosystems where artists are able not only
               to create, but to be protected, supported, remembered, and sustained?


            </p>
            {/* Three Pillars Section */}
            <div className="portfolio-section-divider">
              <h3>Three Pillars of Zikki's Work</h3>

              <div className="pillars-grid" style={{ marginTop: '2rem' }}>
                <div className="pillar-card">
                  <h3>Msichana wa AI</h3>
                  <p><strong>Research & Creative Exploration</strong></p>
                  <p>A research-driven project examining how men and women interact with AI in Kenya, with a focus on African women, digital biases, and inclusive technology design. This initiative combines rigorous research, interviews, and creative exploration to investigate the social, cultural, and emotional implications of AI in everyday life and creative work.</p>
                </div>

                <div className="pillar-card">
                  <h3>Fichua Pazia</h3>
                  <p><strong>Safeguarding & Advocacy</strong></p>
                  <p>A creative research and advocacy project addressing gender inequities, pay gaps, workplace safety, intellectual property challenges, and sexual harassment in Kenya's creative sector. Fichua Pazia highlights policy solutions to safeguard the rights, dignity, and creative agency of artists.</p>
                </div>

                <div className="pillar-card">
                  <h3>NeuroArts</h3>
                  <p><strong>Neurodivergent Creative Ecosystem</strong></p>
                  <p>A nascent initiative designed to support neurodivergent creatives navigating the creative industry. NeuroArts aims to provide advocacy, mentorship, tools, and safe spaces, ensuring that diverse cognitive experiences are valued and amplified within Kenya's creative economy.</p>
                </div>
              </div>

              <p className="note" style={{ marginTop: '2rem', textAlign: 'center' }}>
                In parallel, she has led copyright law training initiatives, supporting over one hundred creatives across Nairobi, Kisumu, Kilifi, and Machakos to better understand intellectual property and ownership within the creative economy.
              </p>
            </div>

            {/* Current Work Section */}
            <div className="portfolio-section-divider">
              <h3>Current Work</h3>
              <p>Zikki is the founder of ZIRAYA Institute, a research and advocacy hub operating at the intersection of AI in creative development, neurodivergence, safeguarding, and the African creative economy. She is currently developing and presenting Mpenzi Mashini, a hybrid theatre performance integrating artificial intelligence with live storytelling to explore gender, technology, and speculative futures for women. The project is part of the broader Msichana wa AI initiative, a research-driven exploration of how artists can collaborate with emerging technologies while critically interrogating their cultural and social implications. Notably, Msichana wa AI investigated how AI is used across gender and how African women navigate AI. Her work also expands into NeuroArts, examining how neurodivergent creatives survive and thrive within Kenya's creative ecosystem, alongside the second phase of Fichua Pazia, deepening her safeguarding advocacy.</p>
            </div>

            {/* Selected Credits */}
            <div className="portfolio-section-divider">
              <h3>Selected Credits</h3>

              <div className="credits-grid">
                <div className="credit-category">
                  <h4>Film / Composer / Actor</h4>
                  <ul>
                    <li><strong>Sincerely Daisy (Netflix)</strong> – Music Featured (Get It EP)</li>
                    <li><strong>Visa Love (Short Film)</strong> – Actor & Composer</li>
                    <li><strong>Africa Magic Original Films (AMOF)</strong> – Commissioned by MultiChoice / Africa Magic</li>
                  </ul>
                </div>

                <div className="credit-category">
                  <h4>Theatre</h4>
                  <ul>
                    <li><strong>Excess (Musical Play)</strong> – Actor & Composer</li>
                    <li><strong>Fiddler on the Roof</strong> – Main Actor</li>
                    <li><strong>Lwanda Man of Stone</strong> (Eric Wainaina's MO Faya) – Performer</li>
                    <li><strong>Fire by 10</strong> – Trainee / Performer</li>
                    <li><strong>Phoenix Players</strong> – Actor, over a dozen productions since 2010</li>
                  </ul>
                </div>

                <div className="credit-category">
                  <h4>Television / Media</h4>
                  <ul>
                    <li><strong>Rush TV Series</strong> (C Through Productions)</li>
                    <li><strong>Voiceover Artist</strong> – Nation Media Group</li>
                    <li><strong>Ads / Commercials</strong> – Writer, Producer, Voice Actor</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Special Projects */}
            <div className="portfolio-section-divider">
              <h3>Special Projects</h3>
              <ul className="special-projects-list">
                <li><strong>Msichana wa AI & Mpenzi Mashini</strong> – Hybrid theatre + AI research exploring gender, creativity, and technology</li>
                <li><strong> Safer Workspaces in the Creative Industry – Fichua Pazia</strong> – Research and advocacy initiative delivering Kenya's first Safe Spaces Toolkit for creatives</li>
                <li><strong> NeuroArts</strong> – Developing support mechanisms and advocacy platforms for neurodivergent creatives</li>
              </ul>
            </div>

            <div className="portfolio-section-divider">
              <h3>Video Portfolio</h3>
              <div className="video-grid">
                {videos.map((video) => (
                  <div key={video.id} className="video-card">
                    <div className="video-container">
                      <iframe
                        width="100%"
                        height="100%"
                        src={video.embedUrl}
                        title={video.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                    <div className="video-caption">
                      <h4>{video.title}</h4>
                      {video.description && <p>{video.description}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Section */}
            <div className="portfolio-contact">
              <h3>Contact</h3>
              <p><strong>Valentine Zikki</strong> – Multidisciplinary Storyteller | Art, Storytelling, Technology & Social Impact</p>
              <p>Email: <a href="mailto:zikki@zirayainstitute.org">zikki@zirayainstitute.org</a> | Phone: 0725 816 126</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ValentineZikkiPortfolio;